import { render, staticRenderFns } from "./BundleComponentsEditor.vue?vue&type=template&id=01097d60&scoped=true"
import script from "./BundleComponentsEditor.vue?vue&type=script&lang=js"
export * from "./BundleComponentsEditor.vue?vue&type=script&lang=js"
import style0 from "./BundleComponentsEditor.vue?vue&type=style&index=0&id=01097d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01097d60",
  null
  
)

export default component.exports